import request from '@/utils/request'

// 查询产品列表
export function noPermissionList(query) {
  return request({
    url: '/system/product/noPermissionList',
    method: 'get',
    params: query
  })
}

// 查询产品详细
export function noPermission(id) {
  return request({
    url: '/system/product/noPermission/' + id,
    method: 'get'
  })
}
